/* global __SHORTCUTS_ENABLED__:false */
import StateController from './StateController';
import { STATE_BOOT, STATE_WELCOME, STATE_CAMPOUT } from '../constants/StateConstants';
import Shortcuts, { ShortcutStub } from 'app/shortcuts/Shortcuts';
import ShortcutsModel from 'app/shortcuts/ShortcutsModel';
import Saves from 'app/model/Saves';
import Transition from 'app/ui/Transition';
import { getGA } from 'analytics/GoogleAnalytics';
// import Captions, { CAPTION } from 'plugins/springroll/Captions';

export default class GameController {
  constructor(game) {
    this.game = game;

    this.gameResets = 1;
  }

  init() {
    // event listeners
    this.onGamePaused = new Phaser.Signal();
    this.onGameResume = new Phaser.Signal();

    // controllers
    this.stateController = new StateController(this.game);

    this.shortcutsModel = new ShortcutsModel();
    if (__SHORTCUTS_ENABLED__) {
      this.shortcuts = new Shortcuts(this.game, { model: this.shortcutsModel, isVisible: false });
      this.shortcuts.create();
    } else {
      this.shortcuts = new ShortcutStub();
    }
  }

  startBoot() {
    this.game.state.start(STATE_BOOT, true, true);
  }

  startLoad() {}

  reloadApp() {
    this.startBoot();
  }

  deleteSave(saveId) {
    this.saves.deleteSave(saveId);
  }

  createSaveId(saveId) {
    this.saves.setSaveID(saveId);
  }

  /*
  ======================================================================
    SHORTCUTS
  ======================================================================
  */
  shortcutDebugPond() {}
  updateShortcutsState() {}
  /*
  ======================================================================
    TRIGGER GAME STATES
  ======================================================================
  */

  loadComplete() {
    // this.captions = new Captions();
    // this.captions.parseGroups(this.game, [
    //   { id: 'olive', type: CAPTION.MAGNIFY },
    //   { id: 'olive', type: CAPTION.NAME },
    // ]);
    this.game.springRollCaptionsPlugin.setData(this.game.cache.getJSON('vos_captions'));
    getGA().track({ action: 'startGame' });
    this.showWelcomeScreen();
  }

  showWelcomeScreen(deleteSave = false) {
    this.game.sounds.stopAllSFX();

    //
    this.shortcuts.reset();
    if (this.game.paused) {
      this.resumeGame();
    }

    //
    if (!this.saves) {
      this.saves = new Saves();
    }

    if (deleteSave) {
      const savedData = this.saves.load();
      savedData.items = null;
      savedData.furnitures = null;
      savedData.characters = null;
      savedData.start_point = null;
      savedData.time = null;
      this.saves.save({ data: savedData });

      // track resets
      getGA().track({ action: 'clickReset', value: this.gameResets });
      this.gameResets++;
    }

    //
    this.startState(STATE_WELCOME, {});
  }

  startGame() {
    getGA().track({ action: 'startLevel' });
    this.startState(STATE_CAMPOUT);
  }

  /*
  ======================================================================
    TRANSITION
  ======================================================================
  */

  getTransition() {
    this.transition = new Transition(this.game);
    return this.transition;
  }

  /*
  =========================================================================================================
    TRIGGER STATE CHANGE
  =========================================================================================================
  */

  startState(stateid, stateprops) {
    this.game.controller.stateController.startState({
      nextState: stateid,
      nextStateParams: [true, false, stateprops],
    });
  }

  /*
  ====================================================================================
    PAUSE / RESUME
  ====================================================================================
  */

  pauseGame() {
    if (!this.game.paused) {
      this.onGamePaused.dispatch();
      this.game.paused = true;
      this.game.sounds.pauseAll();
    }
  }

  resumeGame() {
    if (this.game.paused) {
      this.onGameResume.dispatch();
      this.game.paused = false;
      this.game.sounds.resumeAll();
    }
  }

  /*
  ====================================================================================
    VOICE-OVERS
  ====================================================================================
  */
  playVO(id) {
    this.game.springRollCaptionsPlugin.playCaption(id);
    this.sndVO = this.game.sounds.playVO(id, { spriteID: 'vos' });
    return this.sndVO;
  }

  stopVO() {
    if (this.sndVO) {
      this.game.springRollCaptionsPlugin.stopCaption();
      this.sndVO.stop();
    }
  }
}
